"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FooterContactForm = /*#__PURE__*/function () {
  function FooterContactForm(container) {
    _classCallCheck(this, FooterContactForm);

    this.container = $(container);
    this._fieldsVisible = false;
    this.initShowFieldsHandler();
  }

  _createClass(FooterContactForm, [{
    key: "initShowFieldsHandler",
    value: function initShowFieldsHandler() {
      var _this = this;

      var textarea = "#frm-createFooterContactForm-message";
      $(".form-container").on('focus', textarea, function () {
        if (!_this._fieldsVisible) {
          _this._fieldsVisible = true;

          _this.showFields();
        }
      });
    }
  }, {
    key: "showFields",
    value: function showFields() {
      $('.more-fields', this.container).addClass('visible');
    }
  }]);

  return FooterContactForm;
}();